import { render, staticRenderFns } from "./Fullpage.vue?vue&type=template&id=73e60aff&scoped=true"
import script from "./Fullpage.vue?vue&type=script&lang=js"
export * from "./Fullpage.vue?vue&type=script&lang=js"
import style0 from "./Fullpage.vue?vue&type=style&index=0&id=73e60aff&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e60aff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chaipeng/Desktop/Mico/micous-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e60aff')) {
      api.createRecord('73e60aff', component.options)
    } else {
      api.reload('73e60aff', component.options)
    }
    module.hot.accept("./Fullpage.vue?vue&type=template&id=73e60aff&scoped=true", function () {
      api.rerender('73e60aff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/views/web/home/components/Fullpage.vue"
export default component.exports